import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import type {
  ApiResponse,
  BannerConfigSaveResult,
  BannerEngineConfig,
  UpdateBannerConfigRequest,
} from '@magnetar/admin-api-interfaces'

function failure<T>(code: string, message: string): ApiResponse<T> {
  return { success: false, error: { code, message } } as ApiResponse<T>
}

/** Banner 引擎配置（CR-1）：全域預設與組織覆蓋 */
export const bannerConfigService = {
  save: async (data: UpdateBannerConfigRequest, token: string) => {
    try {
      const response = await apiClient.put<ApiResponse<BannerConfigSaveResult>>(
        '/api/banner_config',
        data,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ApiResponse<BannerConfigSaveResult>
      }
      return failure<BannerConfigSaveResult>('SAVE_BANNER_CONFIG_FAILED', '儲存失敗')
    }
  },

  removeOverride: async (providerId: number, token: string) => {
    try {
      const response = await apiClient.delete<ApiResponse<BannerEngineConfig>>(
        `/api/banner_config/${providerId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ApiResponse<BannerEngineConfig>
      }
      return failure<BannerEngineConfig>('DELETE_BANNER_CONFIG_FAILED', '移除組織設定失敗')
    }
  },
}
